module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('button', {
    class: _vm.setClass(),
    attrs: {
      "id": "gv-button-geocoder-btn",
      "title": "Ricerca Indirizzo"
    },
    on: {
      "click": _vm.onClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-02ca8255!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/GeocoderBtn.vue
// module id = 813
// module chunks = 39